






















import { Component, Vue } from 'vue-property-decorator';
import Popup from '@/components/default/Popup.vue';
import { DxForm, DxSimpleItem, DxLabel, DxRequiredRule } from 'devextreme-vue/form';
import notificationService from '@/services/notificationService';


@Component({
    components: {
        DxForm,
        DxSimpleItem,
        DxLabel,
        DxRequiredRule,
        Popup,
    },
})
export default class MeasurementRoomChangeNamePopup extends Vue {
    private index: number = 0;
    private model: { name: string } = {
        name: '',
    };
    private show: boolean = false;
    private saving: boolean = false;

    public open(index: number, name: string) {
        this.index = index;
        this.model.name = name;
        this.show = true;
    }

    private save() {
        const validationResult = this.form.validate();
        if (validationResult.isValid) {
            this.$emit('input', { index: this.index, name: this.model.name });
            this.show = false;
        } else {
            notificationService.invalidForm();
        }
    }

    get form() {
        const form: any = this.$refs.form;
        return form.instance;
    }
}
